import { PayrollModel } from "../model";
import moment from "moment";
import logger from "../utils/logger";

export async function listOfPayroll() {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/payroll?_where=(uuid,ne,null)&_sort=check_date");
        return await response.json();
    } catch (error) {
        logger.error("listOfPayroll failed", {}, error);
        return [];
    }
}

export async function getFilteredPayroll(filters: any) {
    console.log(filters);

    let _q = "select distinct p.* from payroll p left join consultant c on c.uuid = p.uuid where 1=1 ";

    if (filters.checkDate) {
        _q += " and year(_d_start) = " + filters.checkDate.getFullYear();
        _q += " and month(_d_start) = " + (filters.checkDate.getMonth() + 1);
    } else {
        logger.error("checkDate is null or undefined in getFilteredPayroll");
    }

    if (filters.employee) {
        _q += " and p.uuid = '" + filters.employee + "' ";
    }

    if (filters.activeStatus !== undefined && filters.activeStatus !== null && String(filters.activeStatus).trim() !== "") {
        const as = String(filters.activeStatus).trim().toLowerCase();
        if (as === "active") {
            _q += " and c.active = 1 ";
        } else if (as === "inactive") {
            _q += " and c.active = 0 ";
        }
    }

    if (filters.fortnightly === "first") {
        _q += " and day(_d_start) in (1) ";
    } else if (filters.fortnightly === "second") {
        _q += " and day(_d_start) in (16) ";
    }

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["payroll"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getFilteredPayroll failed", { filters }, error);
        return [];
    }
}

export async function getFilteredPayrollSummary(filters: any) {
    console.log(filters);

    let _q = "select distinct *, sum(net_pay) as _s_np, sum(e_total) as _s_e_total, sum(d_total) as _s_d_total, sum(t_total) as _s_t_total, sum(hrs) as _s_hrs  from payroll where net_pay > 0 ";

    if (filters && filters.checkDate) {
        _q += "  and month(_d_start) = " + (filters.checkDate.getMonth() + 1) + "";
        _q += "  and year(_d_start) = " + filters.checkDate.getFullYear() + "";
    }

    if (filters.employee) {
        _q += " and  uuid = '" + filters.employee + "' ";
    }

    if (filters.groupedUUID) {
        _q += " group by uuid,_d_start ,_d_end ";
    } else {
        _q += " order by uuid ";
    }

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["payroll"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getFilteredPayrollSummary failed", { filters }, error);
        return [];
    }
}

export async function saveBulkPayroll(list: any) {
    console.log(list);
    console.log(list.filter((entry) => entry.hrs > 0));

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/payroll/bulk", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(list.filter((entry) => entry.selected)),
        });
        return await response.json();
    } catch (error) {
        logger.error("saveBulkPayroll failed", {}, error);
        return [];
    }
}

export async function savePayroll(instance: PayrollModel) {
    console.log("Saving payroll:", instance);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/api/payroll", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(instance),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        logger.error("savePayroll failed", { instance }, error);
        throw error;
    }
}

export async function getFortnightPayroll(filters: any) {
    console.log(filters);

    let date = moment(filters.checkDate);
    let _q = "select  * from payroll where  ";

    if (filters.checkDate) {
        _q += "  year(_d_start) = " + date.year();
        _q += " and month(_d_start) = " + (date.month() + 1);
        _q += " and DAY(_d_start) = " + date.date();
    } else {
        logger.error("checkDate is null or undefined in getFortnightPayroll");
    }

    console.log(_q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["payroll"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getFortnightPayroll failed", { filters }, error);
        return [];
    }
}
